import PropTypes from "prop-types";
import React from "react";
import { Trans } from "@lingui/macro";
import Map from "./Map";

export default function SummaryNormal(props) {
  //const [checkedNotification, setCheckedNotification] = useState(false);
  const data = props.data;

  /*const setNotifData = notifData => {
    props.setNotificationData(checkedNotification, notifData);
  };

  const handleNotifState = notifState => {
    setCheckedNotification(notifState);
    props.setNotifState(notifState);
  };*/

  return (
    <>
      <div className="confirm">
        <p>
          <i className="material-icons">done</i>
          <Trans id="W_RENDEZ_VOUS_CONFIRME" />
        </p>
        <p>
          <Trans id="W_RAPPEL_RENDEZ_VOUS" />
        </p>
      </div>

      <div className="inner-summary">
        <div className="head-summary primary-bg">
          <i className="material-icons">date_range</i>
          <span>{data.date_fr}</span>
          <i className="material-icons">access_time</i>
          <span>{data.heure_aff}</span>
        </div>

        <div className="block infos-doctor">
          <img
            src={data.photo_praticien}
            width="70"
            height="70"
            alt={data.nom_praticien}
          />
          <div className="inner-block">
            <p className="name">{data.Infodocteur}</p>
            <p>{data.nom_profession}</p>
          </div>
        </div>

        {/**
        <div className="block notification align-items-center">
          <i className="material-icons">notifications</i>
          <div className="inner-block display-flex">
            <strong className="title">
              <Trans id="QUESTION_RECAP" />
            </strong>
            <FormControlLabel
              control={
                <Switch
                  checked={checkedNotification}
                  onChange={() => handleNotifState(!checkedNotification)}
                  value="checkedNotification"
                  color="primary"
                />
              }
              label={translator()._("W_ACTIVER")}
            />
          </div>
          {checkedNotification && (
            <Notification
              setChecked={setCheckedNotification}
              infoRdv={data}
              setNotificationData={setNotifData}
            />
          )}
        </div>
          */}

        <div className="block">
          {data.fils.length > 0 && (
            <React.Fragment>
              <i className="material-icons">person</i>
              <div className="inner-block">
                <strong className="title">
                  <Trans id="W_PATIENTS" />
                </strong>
                <ul className="list-patients">
                  {data.fils.map((item, key) => (
                    <li key={`name-${key}`}>{item.nom}</li>
                  ))}
                </ul>
              </div>
            </React.Fragment>
          )}
        </div>

        {data.motif && (
          <div className="block">
            <i className="material-icons">assignment</i>
            <p className="motif">
              <strong>
                <Trans id="CP_MES_RDV_TABLE_MOTIF" />
              </strong>{" "}
              : {data.motif}
            </p>
          </div>
        )}

        {data.info_importante && (
          <div className="block">
            <i className="material-icons">warning</i>
            <div className="inner-block">
              <strong className="title">
                <Trans id="W_STEP4_RECAP_CONSIGNES_IMPORTANTES" />
              </strong>
              <div
                dangerouslySetInnerHTML={{
                  __html: data.info_importante
                }}
              />
            </div>
          </div>
        )}

        {data.tel_lieux && (
          <div className="block">
            <i className="material-icons">phone</i>
            <div className="inner-block">
              <a className="phone" href={`tel:${data.tel_lieux}`}>
                {data.tel_lieux}
              </a>
            </div>
          </div>
        )}

        <div className="block align-items-center">
          <i className="material-icons">location_on</i>
          <div className="inner-block display-flex flex-1 align-items-center">
            <div className="address flex-1">
              <strong>{data.nom_lieux}</strong>
              <div dangerouslySetInnerHTML={{ __html: data.adresse_lieux }} />
              <div>{data.code_postal_lieux}</div>
              <div>{data.ville_lieux}</div>
            </div>
            {data.latitude_lieux && data.longitude_lieux && (
              <div id="map" className="flex-1">
                <Map lng={data.longitude_lieux} lat={data.latitude_lieux} />
              </div>
            )}
          </div>
        </div>

        {(data.nom_lieux_service || data.infos_pratiques_lieux_service) && (
          <div className="block">
            <i className="material-icons">home_work</i>
            <div className="inner-block">
              <strong className="title">
                <Trans id="W_SERVICE" />
              </strong>

              {data.nom_lieux_service && <div>{data.nom_lieux_service}</div>}
              {data.infos_pratiques_lieux_service && (
                <div>
                  <Trans id="W_INFOS_PRATIQUE" />:{" "}
                  {data.infos_pratiques_lieux_service}
                </div>
              )}
            </div>
          </div>
        )}

        {data.horaires_ouverture_lieux && (
          <div className="block">
            <i className="material-icons">info</i>
            <div className="inner-block">
              <div
                dangerouslySetInnerHTML={{
                  __html: data.horaires_ouverture_lieux
                }}
              />
            </div>
          </div>
        )}

        {data.type_paiement && (
          <div className="block">
            <i className="material-icons">payment</i>
            <div className="inner-block">
              <strong className="title">
                <Trans id="W_STEP4_RECAP_MOYENS_PAIEMENT" />
              </strong>
              <div dangerouslySetInnerHTML={{ __html: data.type_paiement }} />
            </div>
          </div>
        )}

        {data.tarif_remboursement && (
          <div className="block">
            <i className="material-icons">euro_symbol</i>
            <div className="inner-block">
              <strong className="title">
                <Trans id="W_STEP4_RECAP_TARIF_REMBOURSEMENT" />
              </strong>
              <div
                dangerouslySetInnerHTML={{
                  __html: data.tarif_remboursement
                }}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
}

SummaryNormal.propTypes = {
  data: PropTypes.shape({
    Infodocteur: PropTypes.string,
    adresse_lieux: PropTypes.string,
    code_postal_lieux: PropTypes.string,
    date_fr: PropTypes.string,
    fils: PropTypes.any,
    heure_aff: PropTypes.string,
    horaires_ouverture_lieux: PropTypes.string,
    info_importante: PropTypes.string,
    infos_pratiques_lieux_service: PropTypes.string,
    latitude_lieux: PropTypes.any,
    longitude_lieux: PropTypes.any,
    motif: PropTypes.any,
    nom_lieux: PropTypes.string,
    nom_lieux_service: PropTypes.any,
    nom_praticien: PropTypes.string,
    nom_profession: PropTypes.string,
    photo_praticien: PropTypes.any,
    tarif_remboursement: PropTypes.any,
    tel_lieux: PropTypes.string,
    type_paiement: PropTypes.any,
    ville_lieux: PropTypes.string
  }),
  setNotifState: PropTypes.func,
  setNotificationData: PropTypes.func
};
